import React, { useEffect, useState } from 'react';
import useSelectionSafeDoubleClick from '../../../hooks/common/useSelectionSafeDoubleClick';
import DsButton from '../../common/DsButton';
import DsModal from '../../common/DsModal';
import CastingContextFields from './CastingContextFields';
import { getEventCastingContext, updateEventCastingContext, type CastingContextSettings } from '../../../api/castingReference';
import { formatCastingContextSummary } from '../../../utils/castingPosition';
import '../../../css/common/CastingReference.css';
const Modal = DsModal as React.ComponentType<any>;

export default function CastingContextQuickEdit({ eventId }: { eventId: string }) {
  return <QuickEdit key={eventId} eventId={eventId} />;
}
function QuickEdit({ eventId }: { eventId: string }) {
  const [data, setData] = useState<CastingContextSettings>();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<string>();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const abort = new AbortController(); setLoading(true); setError(''); setDraft(undefined);
    getEventCastingContext(eventId, abort.signal).then(result => { if (!abort.signal.aborted) setData(result); })
      .catch(err => { if (!abort.signal.aborted) setError(err.message); })
      .finally(() => { if (!abort.signal.aborted) setLoading(false); });
    return () => abort.abort();
  }, [eventId, version]);
  const save = async () => {
    if (!draft || saving || !data?.canEdit) return;
    setSaving(true); setError('');
    try { setData(await updateEventCastingContext(eventId, JSON.parse(draft))); setOpen(false); setDraft(undefined); }
    catch (err) { setError((err as Error).message); }
    finally { setSaving(false); }
  };
  const gesture = useSelectionSafeDoubleClick(!!data?.canEdit && !!data.genres?.length && !loading && !open, () => { setError(''); setDraft(undefined); setOpen(true); });
  if (!loading && !error && !data?.genres?.length && !data?.context) return null;
  return <tr className="event-field-row" {...gesture}><th scope="row">演奏難易度</th><td>
    <div className="casting-quick__summary">
      <span>{loading ? '読み込み中…' : data ? formatCastingContextSummary(data.context) : '設定を取得できませんでした'}</span>
    </div>
    {!open && error && <div role="alert">{error}<DsButton variant="secondary" onClick={() => setVersion(v => v + 1)}>再読み込み</DsButton></div>}
    {open && <Modal open title="演奏難易度を設定" size="lg" onClose={() => { if (!saving) { setOpen(false); setDraft(undefined); } }}
      footer={<DsButton variant="primary" disabled={!draft || saving || loading} onClick={save}>{saving ? '保存中…' : '保存'}</DsButton>}>
      {error && <div role="alert">{error}<DsButton variant="secondary" disabled={saving} onClick={() => setVersion(v => v + 1)}>最新の設定を読み込む</DsButton></div>}
      <fieldset className="casting-quick__fields" disabled={saving || loading}>
        <CastingContextFields disabled={saving || loading} key={version} eventId={eventId} genres={data?.genres || []} selectedGenreIds={(data?.genres || []).map(g => g.id)} value={draft} onChange={setDraft}
          saveHint="この画面の保存で参考情報だけを更新します。アーティストには表示・通知されません。" />
      </fieldset>
    </Modal>}
  </td></tr>;
}
